import React, { useEffect, useState, useContext } from 'react'
import { AppContext } from '../../../App'
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'
import useForm from '../../../hooks/useForm'
import imageSiteWeb from '../../../images/imagesiteweb.png'
import Spinner from '../../../components.js/elements/Spinner'
import CardHomeParam from '../../../components.js/serveur/parametres/CardHomeParam'

const INITIAL_STATE = {
    nameList:''
}

const Parametres = () => {
    const { list } = useContext(AppContext)
    const { handleChange, values } = useForm(INITIAL_STATE)
    const [montage, setMontage] = useState(true)

    useEffect(() => {
        window.scrollTo(0, 0)
        setMontage(false)
    },[])

    if (montage) return <Spinner />

    const listCardParam = [
        {title:'SERVICES', link:'/siteWeb'},
        {title:'EQUIPES', link:'/messagePush'},
        {title:'PLANNING', link:'/profil'},
    ]


    return (
        <div className='container-fluid'>
            <HeaderReturn title='Parametres' image={imageSiteWeb} link='/'/>
            {listCardParam.map(l => (
                <CardHomeParam title={l.title} link={l.link} />
            ))}
        </div>
    )
}

export default Parametres

















